import { AppType } from '@alpha-core/alpha-utils/lib/enum/dashboard-enum';
import { BranchStateService, ProjectService } from '@alpha-core/platform-ui';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TabViewModule } from 'primeng/tabview';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { userService } from '../../services/user-service';

interface Dashboard {
    dashboard_url: string;
    user_role: string;
    title: string;
    app: string;
}

@Component({
    selector: 'app-admin-dashboard',
    standalone: true,
    imports: [TabViewModule],
    templateUrl: './admin-dashboard.component.html',
    styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {
    dashboards: Array<Dashboard & { content: SafeResourceUrl }> = [];
    dashboardsNotFound = false;

    private http = inject(HttpClient);
    public sanitizer = inject(DomSanitizer);
    private user = inject(userService);
    private project = inject(ProjectService);
    private branchStateService = inject(BranchStateService);

    async ngOnInit() {
        try {
            const data = await this.loadDashboard();
            if (data?.response?.length > 0) {
                this.dashboards = data.response.map((dashboard: Dashboard) => ({
                    ...dashboard,
                    content: this.sanitizer.bypassSecurityTrustResourceUrl(dashboard.dashboard_url),
                }));

                if (this.dashboards.length === 0) {
                    this.dashboardsNotFound = true;
                }
            } else {
                this.dashboardsNotFound = true;
            }
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            this.dashboardsNotFound = true;
        }
    }

    async loadDashboard(): Promise<{ response: Dashboard[] }> {
        const userInfo = await lastValueFrom(this.user.getUser());
        const project = this.project.fetchCurrentProject();
        const branch: string = this.branchStateService.getBranch() || 'main';
        const requestBody = {
            user_id: userInfo?.response?.username,
            project_id: project?.projectId,
            app: AppType.Admin,
            branch,
        };
        return lastValueFrom(
            this.http.post<{ response: Dashboard[] }>(
                `${environment.ALPHA_UI_ADMIN_SERVICE_URL}/dashboard-service/get-embed-url?branch=${branch}`,
                requestBody,
            ),
        );
    }
}
